export default __webpack_public_path__ + "static/media/Richard Marquez - Developer.3376890c.jpg";